import {BaseCachedService} from "./Core/BaseCachedService";
import {BaseService} from "./Core/BaseService";

class QueryToolService extends BaseCachedService {
    get Url() { return super.Url + "/queryTool"; }

    QueryData(query, withCount, download = false) {
        return this.SendRequest(BaseCachedService.POST, {query, withCount, download});
    }

    DownloadFile(fileName, query) {
        let anchor = document.createElement("a");

        this.SetLoading();

        fetch(this.Url, {
            method: 'POST',
            headers: {'Authorization': BaseService.AUTH_TOKEN},
            body: JSON.stringify({query, withCount: false, download: true})
        })
            .then(response => {
                if (!response.ok) {
                    alert('Unfortunately we have failed to download the file.')
                }
                return response;
            })
            .then(response => response.blob())
            .then(blobby => {
                let objectUrl = window.URL.createObjectURL(blobby);
                anchor.href = objectUrl;
                anchor.download = fileName;
                anchor.click();
                this.SetLoading(false);
                URL.revokeObjectURL(objectUrl);
            });
    }
}

export const service = new QueryToolService();

